import { Deal } from '../types/deal';
import { colors } from '../styles/theme';

export const deals: Deal[] = [
  {
    iconName: "Crown",
    title: "ChatGPT Plus",
    description: "Premium access to ChatGPT-4 and OpenAI's latest features",
    features: [
      "Priority access",
      "Unlimited GPT-4",
      "Advanced plugins",
      "Developer mode"
    ],
    originalPrice: "€20/month",
    studentPrice: "Free",
    color: colors.primary,
    link: "https://my.europeanstudent.org/store/deals"
  },
  {
    iconName: "PlayCircle",
    title: "Disney+",
    description: "Unlimited streaming of movies, series, and documentaries",
    features: [
      "4K UHD & HDR",
      "4 simultaneous screens",
      "Unlimited downloads",
      "Ad-free experience"
    ],
    originalPrice: "€5.99/month",
    studentPrice: "Free",
    color: colors.secondary,
    link: "https://my.europeanstudent.org/store/deals/disney-plus"
  },
  {
    iconName: "Music",
    title: "Spotify Premium",
    description: "Unlimited music and podcasts without ads",
    features: [
      "High-quality audio",
      "Offline mode",
      "Unlimited playlists",
      "Unlimited skips"
    ],
    originalPrice: "€6.06/month",
    studentPrice: "Free",
    color: colors.tertiary,
    link: "https://my.europeanstudent.org/store/deals/spotify-premium-3-months"
  }
];
